import { ShieldCheck, Sparkles, Leaf } from "lucide-react";
import { Reveal, MaskText, Eyebrow } from "@/components/motion";

const PROBLEMS = [
  "Le clienti ti vedono come \"quella del trattamento\", non come l'esperta a cui affidare la pelle.",
  "Per l'anti-age vanno dal medico e tornano da te solo per la pulizia viso.",
  "Rincorri macchinari e mode che durano una stagione.",
  "Il listino resta fermo mentre i costi salgono.",
];

export const Problem = () => (
  <section className="section" data-testid="problem-section">
    <div className="wrap grid gap-14 lg:grid-cols-[0.9fr_1.1fr]">
      <div>
        <Eyebrow>Il problema</Eyebrow>
        <MaskText className="h2 mt-6" lines={["Lavori tanto, ma", "la cliente ti sceglie", <em className="gold-text">ancora per il prezzo?</em>]} />
      </div>
      <div>
        <ol className="border-t border-line">
          {PROBLEMS.map((p, i) => (
            <Reveal key={p} delay={i * 0.08}>
              <li className="group flex gap-6 border-b border-line py-6 transition-colors duration-500 hover:bg-ink2/60">
                <span className="font-serif text-2xl text-gold transition-transform duration-500 group-hover:translate-x-1">0{i + 1}</span>
                <p className="text-[15px] leading-relaxed text-cream md:text-base">{p}</p>
              </li>
            </Reveal>
          ))}
        </ol>
        <Reveal delay={0.2}>
          <p className="mt-10 font-serif text-2xl italic leading-snug text-gold-light md:text-3xl">
            Il problema non sei tu. È il modo in cui ti presenti, e quello che puoi offrire.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);

const PILLARS = [
  { icon: ShieldCheck, t: "Senza aghi", d: "Nessuna pratica invasiva: protocolli che restano nel mondo dell'estetica professionale." },
  { icon: Sparkles, t: "Risultati visibili", d: "La cliente vede il cambiamento allo specchio, e torna." },
  { icon: Leaf, t: "Rispetta la naturalezza", d: "Esalta ciò che c'è già, senza maschere e senza eccessi." },
];

export const NaturalAntiAge = () => (
  <section className="section border-t border-line bg-ink2" data-testid="natural-section">
    <div className="wrap">
      <Eyebrow>Natural Anti-Age · Estetica rigenerativa non invasiva</Eyebrow>
      <div className="mt-6 grid gap-10 lg:grid-cols-2 lg:items-end">
        <MaskText className="h2" lines={["Non coprire.", "Non stravolgere.", <span className="gold-text">Rigenerare.</span>]} />
        <Reveal><p className="lead">Il Natural Anti-Age Skin Lovers è estetica rigenerativa: lavora con la pelle, non contro di lei: la aiuta a ritrovare tono, compattezza e luminosità, rispettando i tratti naturali della cliente. Per te significa offrire un anti-age vero e visibile, in totale sicurezza, che oggi le clienti cercano altrove.</p></Reveal>
      </div>
      <div className="mt-16 grid gap-4 md:grid-cols-3">
        {PILLARS.map(({ icon: Icon, t, d }, i) => (
          <Reveal key={t} delay={i * 0.1} className="h-full">
            <div className="card-lux group flex h-full flex-col p-8 hover:-translate-y-1" data-testid={`pillar-${i}`}>
              <Icon className="h-7 w-7 text-gold transition-transform duration-500 group-hover:scale-110" strokeWidth={1.4} />
              <h3 className="mt-10 text-3xl text-cream">{t}</h3>
              <p className="mt-3 text-sm leading-relaxed text-sand">{d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
